import React from 'react'

import Progress1 from './Progress1'
import Progress2 from './Progress2'
import Progress3 from './Progress3'
import Progress4 from './Progress4'
import Progress5 from './Progress5'

/**
 * プログレストラッカー（進行度は1~5まで）
 */
const ProgressTracker: React.FC<ProgressTrackerProps> = (props) => {
  const renderSwitch = (): React.ReactNode => {
    switch (props.progress) {
      case 1:
        return <Progress1 />
      case 2:
        return <Progress2 />
      case 3:
        return <Progress3 />
      case 4:
        return <Progress4 />
      case 5:
        return <Progress5 />
      default:
        return <span />
    }
  }
  return <React.Fragment>{renderSwitch()}</React.Fragment>
}

export type ProgressTrackerProps = {
  progress: number
}

export default ProgressTracker
